import { createVNode as d, mergeProps as o } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FeedbackFilledStandard.js";
import i from "../components/PfIcon.js";
const e = (r, t) => {
  const a = {
    ...r,
    ...t.attrs
  };
  return d(i, o(a, {
    icon: l
  }), null);
};
e.displayName = "FeedbackFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
